let apiUrl = "https://artstep.com.ua/api/v1";
let apiKey = "123456";

let apiUrlShop = {
    "art-step": "https://artstep.com.ua/api"
}

export default {
    apiUrl: apiUrl,
    apiKey: apiKey,
    apiUrlShop: apiUrlShop
};